import { render, staticRenderFns } from "./HistorySwiper.vue?vue&type=template&id=be298fd6&scoped=true"
import script from "./HistorySwiper.vue?vue&type=script&lang=js"
export * from "./HistorySwiper.vue?vue&type=script&lang=js"
import style0 from "./HistorySwiper.vue?vue&type=style&index=0&id=be298fd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be298fd6",
  null
  
)

export default component.exports